/*
 * @Author: fangchutao
 * @Description: 合同多语言配置包
 * @Date: 2019-08-26 16:58:06
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-04-10 18:32:59
 */
export default {
  '云POS模块价格说明': '云POS模块价格说明',
  '功能模块': '功能模块',
  '配置化模块': '配置化模块',
  'SAAS租用': 'SAAS租用',
  '购买': '购买',
  '云POS硬件支持情况': '云POS硬件支持情况',
  '物流模块': '物流模块',
  '基础物流模块': '基础物流模块',
  'O2O物流模块': 'O2O物流模块',
  '365/年': '365/年',
  '199/年': '199/年',
  '600元+100元综合维护费/年': '600元+100元综合维护费/年',
  '200元+100元综合维护费/年': '200元+100元综合维护费/年',
  '收银模块': '收银模块',
  '云POS（物流+收银）': '云POS（物流+收银）',
  '730/年': '730/年',
  '1200元+200元综合维护费/年': '1200元+200元综合维护费/年',
  '900/年': '900/年',
  '1400元+200元综合维护费/年': '1400元+200元综合维护费/年',
  '联系我们': '聯系我們',
  '总部:': '總部',
  '地址': '地址',
  '电话': '電話',
  '邮箱': '郵箱',
  '客服中心:': '客服中心',
  '犀牛EPOS · PC版': '犀牛EPOS · PC版',
  '全新上线，给你最美、最流畅的店铺Pos体验': '全新上線，給妳最美、最流暢的店鋪Pos體驗',
  '下载最新版': '下載最新版',
  '运行环境：Win7或更高版本': '運行環境：Win7或更高版本',
  '品牌Webpos下载': '品牌Webpos下載',
  '下载最新定制版': '下載最新定制版',
  '更多': '更多',
  '历史版本': '歷史版本',
  '下载该版本': '下載該版本',
  '收银': '收銀',
  '物流': '物流',
  '报表': '報表',
  '查会员': '查會員',
  '犀牛EPOS': '犀牛EPOS',
  '产品': '產品',
  '客户': '客戶',
  'PC版下载': 'PC版下載',
  '移动版下载': '移動版下載',
  '智慧零售 赋能门店': '智慧零售 賦能門店',
  '为您提供新零售所需要的一切': '為您提供新零售所需要的壹切',
  '销售退换货': '銷售退換貨',
  '预售/赠送': '預售/贈送',
  '流行促销': '流行促銷',
  '会员/积分': '會員/積分',
  '储值/券': '儲值/券',
  '收发货': '收發貨',
  '盘点': '盤點',
  '电商发货/退货': '電商發貨/退貨',
  '真正的移动收银神器': '真正的移動收銀神器',
  '商米/PDA/平板/手机': '商米/PDA/平板/手機',
  '专为服饰零售行业客户而生': '專為服飾零售行業客戶而生',
  '广州丽晶软件科技股份有限公司致力做最杰出的服饰管理专家，着意创建先进、精简、实用高效的电脑信息管理系统，用专注、创新见证着中国服装产业信息化发展进程。丽晶不仅仅要让企业在标准化的行业体系之中占有一席之地，达到灵活调度企业资源，快速感知市场变化，准确规划运营策略，实现销售增长的目的，更要竭尽全力增强服饰企业本身的独特竞争力，指引应用者凭添果敢的能力，激发决策者闪现睿智的灵感，在现在和未来发展与竞争中不断超越！': '廣州麗晶軟件科技股份有限公司致力做最傑出的服飾管理專家，著意創建先進、精簡、實用高效的電腦信息管理系統，用專註、創新見證著中國服裝產業信息化發展進程。麗晶不僅僅要讓企業在標準化的行業體系之中占有壹席之地，達到靈活調度企業資源，快速感知市場變化，準確規劃運營策略，實現銷售增長的目的，更要竭盡全力增強服飾企業本身的獨特競爭力，指引應用者憑添果敢的能力，激發決策者閃現睿智的靈感，在現在和未來發展與競爭中不斷超越！',
  '下载': '下載',
  '全国热线': '全國熱線',
  '周一至周五 9:00-18:00': '周壹至周五 9:00-18:00',
  '公司邮箱': '公司郵箱',
  '粤ICP备12071402号-7': '粵ICP備12071402號-7',
  '粤ICP备12071402号': '粵ICP備12071402號',
  '关于我们': '關於我們',
  '扫码下载，货品管理尽在掌中': '掃碼下載，貨品管理盡在掌中',
  '安卓平板下载': '安卓平板下載',
  '安卓手机下载': '安卓手機下載',
  'iPhone下载': 'iPhone下載',
  'iPad下载': 'iPad下載',
  '品牌订制下载': '品牌訂制下載',
  '总部': '總部',
  '传真': '傳真',
  '点击下载': '點擊下載',
  '犀牛EPOS · 定制版': '犀牛EPOS · 定制版',
  '移动端': '移動端',
  '安卓手机': '安卓手機',
  '安卓平板': '安卓平板',
  '企业后台登录': '企業後臺登錄',
  '运营管理后台': '運營管理後臺',
  '定制版下载': '定制版下載',
  '南京市中山东路18号国际贸易中心12层C3座': '南京市中山東路18號國際貿易中心12層C3座',
  '广州番禺区番禺大道北555号天安节能科技园15号楼102': '廣州番禺區番禺大道北555號天安節能科技園15號樓102'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-hant/home.js